import { useEffect } from "react";
import LegalLayout from "@/components/LegalLayout";
import { TERMS_SECTIONS } from "@/content/legal";

export default function Terms() {
  useEffect(() => {
    document.title = "Terms of Use | Knot Forgotten";
  }, []);

  return (
    <div data-testid="terms-page">
      <LegalLayout
        eyebrow="Legal"
        title="Knot Forgotten Terms of Use"
        effective="September 21, 2026"
        updated="September 21, 2026"
        sections={TERMS_SECTIONS}
      >
        <p className="mt-10 border-t border-slate-200 pt-6 text-sm text-slate-500">
          By accessing or using the Knot Forgotten mobile application and related services, you agree to
          these Terms. If you do not agree, do not use the Services.
        </p>
      </LegalLayout>
    </div>
  );
}
